import { createContext } from "react";

export interface NotificationCountType {
  count: number;
}

interface InitialStateType {
  notificationCountState: NotificationCountType;
  notificationCountStateSetState: React.Dispatch<
    React.SetStateAction<NotificationCountType>
  >;
}

const NotificationCountContext = createContext<InitialStateType[]>([]);

export default NotificationCountContext;
